/**
 * `/sampling/styles/$styleId/samples` — Sampling tab of the Style File, but
 * addressed by the module that owns the workflow per issue #156 rule 4.
 * The Style identity stays in the path; the shell + tab content are the
 * same as `/merchandising/styles/$styleId/...`.
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleSamplesPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/sampling/styles/$styleId/samples")({
  component: StyleSamplesRoute,
});

function StyleSamplesRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Sampling", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Sampling" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleSamplesPage styleId={styleId} />
    </WorkspaceShell>
  );
}
